<flx-heading size="medium" align="center" weight="extra-light" type="creation">{{ addressConfirmationText }}</flx-heading>
<p class="policy-address">
	<b>Installation Address:</b> {{ (policyAddress$ | async) || policyAddressFallback }}
</p>
<ng-container *ngIf="!isOffline; else offline">
	<ng-container *ngIf="hasMinimumAddress && locationPickerForm.get('address_details'); else noMaps">
		<form [formGroup]="locationPickerForm" class="le-map">
			<div class="address-found">
				<flx-heading size="small" align="center" color="custom-background" margin="0">Address Found</flx-heading>
				<div class="box">
					<div class="heading">
						<strong align="end">Policy Address</strong>
						<strong align="start">Address Found</strong>
					</div>
					<br />
				<ng-container *ngIf="policyAddressObject$ | async as policyAddressObject; else policyAddressFallbackTpl">
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObject?.address) }}</span>
						<flx-circle-indicator
							[color]="compareAddressParts(policyAddressObject?.address, locationPickerForm.value['searched_address']?.address)"
						></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.address) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObject?.suburb) }}</span>
						<flx-circle-indicator
							[color]="compareAddressParts(policyAddressObject?.suburb, locationPickerForm.value['searched_address']?.suburb)"
						></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.suburb) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObject?.city) }}</span>
						<flx-circle-indicator [color]="compareAddressParts(policyAddressObject?.city, locationPickerForm.value['searched_address']?.city)"></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.city) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObject?.postal_code) }}</span>
						<flx-circle-indicator
							[color]="compareAddressParts(policyAddressObject?.postal_code, locationPickerForm.value['searched_address']?.suburb_code)"
						></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.suburb_code) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(province) }}</span>
						<flx-circle-indicator [color]="compareAddressParts(province, locationPickerForm.value['searched_address']?.province)" color="green"></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.province) }}</span>
					</div>
				</ng-container>
				<ng-template #policyAddressFallbackTpl>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObjectFallback.propertystreetaddress) }}</span>
						<flx-circle-indicator
							[color]="compareAddressParts(policyAddressObjectFallback.propertystreetaddress, locationPickerForm.value['searched_address']?.address)"
						></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.address) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObjectFallback.propertysuburb) }}</span>
						<flx-circle-indicator
							[color]="compareAddressParts(policyAddressObjectFallback.propertysuburb, locationPickerForm.value['searched_address']?.suburb)"
						></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.suburb) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObjectFallback.propertycity) }}</span>
						<flx-circle-indicator [color]="compareAddressParts(policyAddressObjectFallback.propertycity, locationPickerForm.value['searched_address']?.city)"></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.city) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(policyAddressObjectFallback.suburbcode) }}</span>
						<flx-circle-indicator
							[color]="compareAddressParts(policyAddressObjectFallback.suburbcode, locationPickerForm.value['searched_address']?.suburb_code)"
						></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.suburb_code) }}</span>
					</div>
					<div class="line">
						<span>{{ displayPropertyWithValue(province) }}</span>
						<flx-circle-indicator [color]="compareAddressParts(province, locationPickerForm.value['searched_address']?.province)" color="green"></flx-circle-indicator>
						<span>{{ displayPropertyWithValue(locationPickerForm.value['searched_address']?.province) }}</span>
					</div>
				</ng-template>
				</div>
			</div>
			<div class="confirmed-address" *ngIf="locationSearched | async">
				<flx-heading size="small" align="center" color="custom-background" margin="0">Pinned Address</flx-heading>
				<br />
				<div class="details">
					<div *ngIf="((isInSA | async) === false || (isInSA | async) === null || (isInSA | async) === undefined ) && (locationSearched | async)" class="warning-block">Not in South Africa</div>
					<div *ngIf="locationPickerForm.value['searched_address']?.address">Street : {{ locationPickerForm.value['searched_address']?.address }}</div>
					<div *ngIf="locationPickerForm.value['searched_address']?.suburb">Suburb : {{ locationPickerForm.value['searched_address']?.suburb }}</div>
					<div *ngIf="locationPickerForm.value['searched_address']?.city">City : {{ locationPickerForm.value['searched_address']?.city }}</div>
					<div *ngIf="locationPickerForm.value['searched_address']?.suburb_code">Postal Code : {{ locationPickerForm.value['searched_address']?.suburb_code }}</div>
					<div *ngIf="locationPickerForm.value['searched_address']?.province">Province : {{ locationPickerForm.value['searched_address']?.province }}</div>
					<br />
					<div *ngIf="locationPickerForm.value['searched_address']?.latitude">Latitude : {{ locationPickerForm.value['searched_address']?.latitude | number: '1.2-5' }}</div>
					<div *ngIf="locationPickerForm.value['searched_address']?.longitude">Longitude : {{ locationPickerForm.value['searched_address']?.longitude | number: '1.2-5' }}</div>
				</div>
			</div>
			<flx-location-picker [formControlName]="'address_details'" [showSearch]="true" [theme]="(activeTheme | async) ?? defaultTheme"></flx-location-picker>
		</form>
	</ng-container>
	<ng-template #noMaps> <flx-heading size="small" align="center">Please confirm address before selecting a location.</flx-heading> </ng-template>
</ng-container>
<ng-template #offline> <flx-alert type="danger" [message]="offlineMessage"></flx-alert> </ng-template>
